export default __webpack_public_path__ + "static/media/portrait-doctor.7153b7fe.jpg";